import { useUser } from '../../Hooks/useUser'
import { useGetChatTokenQuery } from '../../Redux/api/chatApi'
import StreamChatContainer from './Components/StreamChatContainer'

export const Messages = () => {
    // /* ******************** Hooks ******************** */
    const { data:tokenResponse } = useGetChatTokenQuery();
    const { locator } = useUser();
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <>
            {tokenResponse?.token && locator &&
                <StreamChatContainer 
                token={tokenResponse.token}
            /> }
        </>
    )
}